import { render, staticRenderFns } from "./ChangeItem.vue?vue&type=template&id=3dbebe4b"
import script from "./ChangeItem.vue?vue&type=script&lang=ts"
export * from "./ChangeItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports